import { gtmEvent, filterUndefinedAndEmptyValues } from '../../../utils/gtmEvents';
const ctaClickGtmEvent = ({ event, ctaType, ctaPlacement, linkText, linkUrl, componentType, modelName, trimName, bodyStyle, availabilityFlag, }) => {
    gtmEvent(filterUndefinedAndEmptyValues({
        event,
        cta_type: ctaType,
        cta_placement: ctaPlacement,
        link_text: linkText,
        link_url: linkUrl,
        component_type: componentType,
        model: modelName,
        trim: trimName,
        body_style: bodyStyle,
        availability_flag: availabilityFlag,
    }));
};
export default ctaClickGtmEvent;
